export enum KeyConfigurations {
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ENTER = 'Enter',
  TAB = 'Tab',
  ESCAPE = 'Escape',
  HOME = 'Home',
  END = 'End',
  SPACE = ' ',
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
  SHIFT = 'Shift',
  CONTROL = 'Control',
  ALT = 'Alt',
  META = 'Meta', // Windows: "Meta" is the Windows key; Mac: it's the Command (⌘) key
  CAPS_LOCK = 'CapsLock',
  PAGE_UP = 'PageUp',
  PAGE_DOWN = 'PageDown',
  INSERT = 'Insert',
  F1 = 'F1',
  F2 = 'F2',
  F3 = 'F3',
  F4 = 'F4',
  F5 = 'F5',
  F6 = 'F6',
  F7 = 'F7',
  F8 = 'F8',
  F9 = 'F9',
  F10 = 'F10',
  F11 = 'F11',
  F12 = 'F12',
  NUM_LOCK = 'NumLock',
  SCROLL_LOCK = 'ScrollLock',
  PAUSE = 'Pause',
  CONTEXT_MENU = 'ContextMenu',

  // Number keys (top row)
  DIGIT_0 = '0',
  DIGIT_1 = '1',
  DIGIT_2 = '2',
  DIGIT_3 = '3',
  DIGIT_4 = '4',
  DIGIT_5 = '5',
  DIGIT_6 = '6',
  DIGIT_7 = '7',
  DIGIT_8 = '8',
  DIGIT_9 = '9',

  // Letter keys
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  H = 'h',
  I = 'i',
  J = 'j',
  K = 'k',
  L = 'l',
  M = 'm',
  N = 'n',
  O = 'o',
  P = 'p',
  Q = 'q',
  R = 'r',
  S = 's',
  T = 't',
  U = 'u',
  V = 'v',
  W = 'w',
  X = 'x',
  Y = 'y',
  Z = 'z',

  // Punctuation & Symbols
  SEMICOLON = ';',
  EQUAL = '=',
  COMMA = ',',
  MINUS = '-',
  PERIOD = '.',
  SLASH = '/',
  BACKQUOTE = '`',
  BRACKET_LEFT = '[',
  BACKSLASH = '\\',
  BRACKET_RIGHT = ']',
  QUOTE = "'",
}
